import React, { useContext } from "react";
import DropDown from "./DropDown";
import Context from "./Context";

const DropdownsList = () => {
	const {
		data: { filters, indexPage },
	} = useContext(Context);

	if (filters.length === 0) return null;

	if (indexPage === "stories") {
		return filters.map((dropDown) => {
			return (
				<DropDown
					key={dropDown.region.slug}
					filterKey={dropDown.region.slug}
					dropDownFilters={dropDown.region.filters}
					DropDownLabel={dropDown.region.title}
				/>
			);
		});
	}

	return filters.map((dropDown) => {
		return (
			<DropDown
				key={dropDown.category.slug}
				filterKey={dropDown.category.slug}
				dropDownFilters={dropDown.category.filters}
				DropDownLabel={dropDown.category.title}
			/>
		);
	});
};

export default DropdownsList;
